import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PriceSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PriceSVG;
